import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@app/stores';

/**
 * Guard que bloquea el acceso de subusuarios a rutas exclusivas del usuario principal.
 * Llama a ping() para garantizar que el usuario está cargado antes de evaluar,
 * ya que los guards de canActivate corren en paralelo.
 */
export const principalGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Los guards de canActivate corren en paralelo. Sin este await, el usuario
  // aún no está cargado cuando este guard se ejecuta. _pingPromise deduplica
  // la llamada HTTP para que solo se haga una petición aunque varios guards
  // llamen a ping() al mismo tiempo.
  await authStore.ping();

  if (authStore.esSubusuario()) {
    router.navigate(['inicio']);
    return false;
  }

  return true;
};
